import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import API from '@Services/apiAxios';

interface Destination {
  city: string;
  state: string;
  country: string;
  pincode: string | number;
}
interface Source {
  city: string;
  state: string;
  country: string;
  pincode: string | number;
}
interface Box {
  weight: string | number;
  length: number;
  width: number;
  height: number;
}
interface Package {
  box: Box[];
  unitOfMeasurement: string;
}
interface ShipmentPayload {
  destination: Destination;
  source: Source;
  shipmentType: string;
  weight: number;
  package: Package;
  document: boolean;
  dropOff: boolean;
  userId: string;
  organizationName: boolean;
}

interface RatesState {
  loading: boolean;
  error: string | null;
  data: any;
}

const initialState: RatesState = {
  loading: false,
  error: null,
  data: null,
};

// Async thunk for bulk rates
export const fetchWarehouseBulkRates = createAsyncThunk(
  'warehouseRates/fetchBulkRates',
  async (shipments: ShipmentPayload[], { rejectWithValue }) => {
    try {
      const response = await API.post('/shipment/rate/newapibulkrates', { shipments });
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const ratesSlice = createSlice({
  name: 'warehouseRates',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchWarehouseBulkRates.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehouseBulkRates.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchWarehouseBulkRates.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch rates';
      });
  },
});

export default ratesSlice.reducer;
